// extracted by mini-css-extract-plugin
export default {"legalDetailsContainer":"WBrSvu","copyright":"zfZ5fe","copyrightText":"iqSx7W","longLiveDogs":"MMfCf7","legalDetails":"onWOO_","linkWrapper":"UhdlKU","link":"dyFeyW"};